import React, { useState, useEffect } from "react";
import Button from "../../../../component/Button";
import { useNavigate } from "react-router-dom";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ConfirmationModal from "../../../../modalComponents/ConfirmationModal";
import CustomerInformation from "./CustomerInformation";
import MessageCard from "./MessageCard";
import TitleCard from "./TitleCard";
import classes from "./style.module.scss";
import DisplayCard from "./DisplayCard";
import Exported from "../../../../service/endpoints";
import request from "../../../../service";
import { Toast } from "../../../../service/toast";

const ViewNotifyDetails = (props) => {
  const { notification_id, handleDelete, setCreateNotificationModal } = props;
  const [showEditPopUp, setShowEditPopUp] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [notoficationInfo, setnotoficationnfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getUserDetails();
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const getUserDetails = async () => {
    let url = `${Exported.Endpoints.getNotificationDetails}`;
    let paramsObj = {
      notification_id: notification_id,
    };
    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          setnotoficationnfo(res?.data?.data);
        } else {
          setnotoficationnfo(null);
        }
      })
      .catch((err) => {
        console.log(err, "err");
        setnotoficationnfo(null);
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };

  const redirectBack = () => {
    navigate("/admin/notification");
  };

  const handleClose = () => {
    setShowDeletePopup(false);
  };

  return (
    <>
      <div className={``}>
        <div className={`w-[100%] flex items-center justify-between`}>
          <div className={`layout-title flex items-center`}>
            <div
              className="mr-2 flex items-center cursor-pointer"
              onClick={() => redirectBack()}
            >
              <ArrowBackIosOutlinedIcon />
            </div>
            <div>Notification Details</div>
            <div className={classes.successRole}>Active</div>
          </div>
          <div className="flex items-center">
            <Button
              text={"Edit"}
              className={`mr-4 `}
              smallBtn
              secondary
              onClick={() => {
                // setShowEditPopUp(true);
                navigate(`?type=edit?id=${notification_id}`);
                setCreateNotificationModal(true);
              }}
            />
            <Button
              text={"Delete"}
              className={``}
              smallBtn
              onClick={() => setShowDeletePopup(true)}
            />
          </div>
        </div>
        <div className="my-8">
          <CustomerInformation notoficationInfo={notoficationInfo} />
          <MessageCard notoficationInfo={notoficationInfo} />
          <TitleCard notoficationInfo={notoficationInfo} />
          <DisplayCard notoficationInfo={notoficationInfo} />
        </div>
      </div>
      {showDeletePopup ? (
        <ConfirmationModal
          isOpen={showDeletePopup}
          handleSuccess={() => {
            handleDelete(notification_id);
            redirectBack();
          }}
          closePopUp={handleClose}
          warningText={"Confirmation"}
          modalText={"Are you sure to delete this notification?"}
          confirmText={"Yes"}
          cancelText={"No"}
          primaryBtnConfirm={false}
        />
      ) : null}
    </>
  );
};

export default ViewNotifyDetails;
